import React, { useState, useEffect, useReducer, useContext } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { getDepositSession } from 'school-space-client/api';
import { UserContext } from 'school-space-client/components';

function reducer(state, action) {
    switch (action.type) {
        case 'useEffectUpdate':
            return {
                ...state,
                ...action.payload,
                price: {
                    amount: 100.0,
                    currency: action.payload.currency,
                    quantity: 1
                }
            };
        case 'setLoading':
            return { ...state, loading: action.payload.loading };
        case 'setError':
            return { ...state, error: action.payload.error };
        default:
            throw new Error();
    }
}

const Deposit = () => {
    const [isChecked, setIsChecked] = useState(false);
    const user = useContext(UserContext);
    const [state, dispatch] = useReducer(reducer, {
        quantity: 1,
        price: null,
        loading: false,
        error: null,
        stripe: null
    });

    useEffect(() => {
        async function fetchConfig() {
            const { REACT_APP_STRIPE_PUBLIC_KEY: publicKey } = process.env;
            const unitAmount = 100;
            const currency = 'GBP';
            dispatch({
                type: 'useEffectUpdate',
                payload: { unitAmount, currency, stripe: await loadStripe(publicKey) }
            });
        }
        fetchConfig();
    }, []);

    const handleClick = async () => {
        dispatch({ type: 'setLoading', payload: { loading: true } });
        const { id: sessionId } = await getDepositSession(user.id);
        const { error } = await state.stripe.redirectToCheckout({
            sessionId
        });
        if (error) {
            dispatch({ type: 'setError', payload: { error } });
            dispatch({ type: 'setLoading', payload: { loading: false } });
        }
    };

    return (
        <>
            <div className="">
                {user.customerDeposits === null ? (
                    <>
                        <h5 className="main-title">Booking Deposit</h5>
                        <p className="subTitle">
                            We require a £100 refundable deposit to make sure your bookings are
                            reserved as quickly as possible.
                        </p>
                        <p className="subTitle">
                            By entering your payment details to pay this deposit, you authorise
                            School Space to save these payment details for any future events that
                            you book in line with our usual invoice payment terms. You can change
                            your payment details at any time.
                        </p>
                        <p className="subTitle">
                            The next time you book with us, we'll use your securely stored payment
                            details to charge the balance of your invoice on the invoice due date.
                        </p>

                        <div className="mt-2 mb-2">
                            <label className="flex items-center">
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={e => setIsChecked(e.target.checked)}
                                />
                                <span className="text-muted mb-2 ml-2">
                                    I have read and agree to the{' '}
                                    <a
                                        href="https://school-space.org/terms-conditions"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Terms and Conditions
                                    </a>
                                </span>
                            </label>
                        </div>

                        <button
                            className="btn btndeposit"
                            disabled={!isChecked}
                            onClick={handleClick}
                            type="button"
                        >
                            Pay Deposit
                        </button>
                    </>
                ) : (
                    <div className="d-flex justify-content-between filePathbox">
                        <div
                            className="d-flex justify-content-start align-items-center"
                            style={{ marginRight: '10px' }}
                        >
                            <img src="images/safe.png" alt="close" />
                        </div>
                        <div className="deposit-content">
                            <p className="filename">Deposit Paid</p>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};
export default Deposit;
